import * as types from 'containers/pages/announcementManagement/constants';
import { AnnouncementFormData } from 'containers/pages/announcementManagement/types';

interface AnnouncementAction {
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any;
}

const announcementFormReducer = (state: AnnouncementFormData, action: AnnouncementAction): AnnouncementFormData => {
  switch (action.type) {
    case types.RESET:
    case types.ANNOUNCEMENT_CONVERT:
      return action.payload;
    default:
      if (action.type in state) {
        return { ...state, [action.type]: action.payload };
      }
      return state;
  }
};

export default announcementFormReducer;
